const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

// Замена <input type="month">: Safari на Mac его не поддерживает и показывает обычное
// текстовое поле — туда вписывали «сентябрь», и сервер падал на разборе даты.
// value/onChange — строка 'YYYY-MM' или '' (пусто).
export default function MonthSelect({ value, onChange, disabled, allowEmpty = true, style }) {
  const [year, month] = value ? value.split('-') : ['', ''];
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear - 3; y <= currentYear + 2; y++) years.push(String(y));
  if (year && !years.includes(year)) years.unshift(year);

  // Выбрали только одну половину — вторую подставляем (текущий год / январь), чтобы значение
  // всегда было валидным; выбор пустого пункта в любом из списков очищает значение целиком.
  const pickMonth = (m) => onChange(m ? `${year || currentYear}-${m}` : '');
  const pickYear = (y) => onChange(y ? `${y}-${month || '01'}` : '');

  return (
    <div style={{ display: 'flex', gap: 6, ...style }}>
      <select value={month} disabled={disabled} onChange={e => pickMonth(e.target.value)}>
        {(allowEmpty || !month) && <option value="">Месяц</option>}
        {MONTHS.map((name, i) => {
          const m = String(i + 1).padStart(2, '0');
          return <option key={m} value={m}>{name}</option>;
        })}
      </select>
      <select value={year} disabled={disabled} onChange={e => pickYear(e.target.value)}>
        {(allowEmpty || !year) && <option value="">Год</option>}
        {years.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
}
